import { useState, useEffect, useRef } from "react";

const SvgImg = ({
  src,
  highlightColor,
  scale,
  selected,
  displayBorder = false,
  size = 75,
}) => {
  const [svgContent, setSvgContent] = useState(null);
  const svgRef = useRef(null);

  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await fetch(src);
        const svgText = await response.text();
        setSvgContent(svgText);
      } catch (error) {
        console.error("Error fetching SVG:", error);
      }
    };

    fetchSvg();
  }, [src]);

  useEffect(() => {
    if (svgContent && svgRef.current) {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
      const svgElement = svgDoc.querySelector("svg");

      if (svgElement) {
        const paths = svgElement.querySelectorAll("*[fill]");
        paths.forEach((path) => {
          path.setAttribute("fill", highlightColor || "#000000");
        });

        const svgWidth = svgElement.getAttribute("width");
        const svgHeight = svgElement.getAttribute("height");
        const viewBox = svgElement.getAttribute("viewBox");

        const width = svgWidth || size;
        const height = svgHeight || size;

        if (!viewBox) {
          svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
        }

        const aspectRatio = width / height;

        svgElement.setAttribute("preserveAspectRatio", "xMidYMid meet");

        const containerWidth = size;
        const containerHeight = size;

        if (aspectRatio > 1) {
          svgElement.setAttribute("width", containerWidth);
          svgElement.setAttribute("height", containerWidth / aspectRatio);
        } else {
          svgElement.setAttribute("height", containerHeight);
          svgElement.setAttribute("width", containerHeight * aspectRatio);
        }
      }

      svgRef.current.innerHTML = svgElement ? svgElement.outerHTML : "";
    }
  }, [svgContent, highlightColor, size]);

  return (
    <div
      className={`${
        selected && displayBorder && "border-2 border-teal-500 rounded-xl "
      } p-2`}
    >
      <div
        ref={svgRef}
        style={{
          width: size,
          fill: highlightColor,
          stroke: highlightColor,
          height: size,
          display: "inline-block",
        }}
        className={`${scale && "lg:scale-125"}`}
      />
    </div>
  );
};
export default SvgImg;

export const LogoSVG = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="100%"
  >
    <g id="Layer">
      <path
        id="Layer"
        fill="#ffdc00"
        d="m269 323.6c-7.5-6.4-18.5-6.4-26 0l-206.4 175.5c3.5 3.3 8.3 5.4 13.6 5.4h411.6c5.3 0 10.1-2.1 13.6-5.4z"
      />
      <path
        id="Layer"
        fill="#ffce00"
        d="m291.4 342.7l184 156.4c3.9-3.7 6.4-8.9 6.4-14.6v-274z"
      />
      <path
        id="Layer"
        fill="#ffce00"
        d="m36.6 499.1l184-156.4-190.4-132.2v274c0 5.7 2.5 10.9 6.4 14.6z"
      />
      <path
        id="Layer"
        fill="#fbbd00"
        d="m36.6 499.1l184-156.4-11.7-8.1-178.6 151.8c0.5 5 2.8 9.4 6.3 12.7z"
      />
      <path
        id="Layer"
        fill="#fbbd00"
        d="m475.4 499.1l-184-156.4 11.7-8.1 178.6 151.8c-0.5 5-2.8 9.4-6.3 12.7z"
      />
      <path id="Layer" fill="#ff7e00" d="m87.1 162.1v87.9l-56.9-39.5z" />
      <path
        id="Layer"
        fill="#ff6700"
        d="m30.2 210.5l56.9 39.5v-18.1l-45.2-31.4z"
      />
      <path id="Layer" fill="#ff7e00" d="m424.9 162.1v87.9l56.9-39.5z" />
      <path
        id="Layer"
        fill="#ff6700"
        d="m424.9 231.9v18.1l56.9-39.5-11.7-10z"
      />
      <path
        id="Layer"
        fill="#fff0c0"
        d="m220.6 342.7l22.4-19.1c7.5-6.4 18.5-6.4 26 0l22.4 19.1 133.5-92.7v-242.5h-337.8v242.5z"
      />
      <path
        id="Layer"
        fill="#ffe394"
        d="m291.4 324.7l-22.4-19.1c-7.5-6.4-18.5-6.4-26 0l-22.4 19.1-133.5-92.8v18.1l133.5 92.7 22.4-19.1c7.5-6.4 18.5-6.4 26 0l22.4 19.1 133.5-92.7v-18.1z"
      />
      <g id="Layer"></g>
      <g id="Layer">
        <path
          id="Layer"
          fillRule="evenodd"
          fill="#000000"
          d="m474.3 316.6v-91.8l-170.5 118.5 170 144.5q0.5-1.6 0.5-3.3v-137.9c0-4.1 3.3-7.5 7.5-7.5 4.2 0 7.5 3.4 7.5 7.5v137.9c0 7.5-3.2 14.9-8.7 20.1q0 0 0 0c-5.2 4.8-11.8 7.4-18.8 7.4h-411.6c-6.9 0-13.6-2.6-18.7-7.4q-0.1 0-0.1 0c-5.5-5.2-8.7-12.6-8.7-20.1v-274c0-2.2 1-4.4 2.6-5.8l54.2-46v-53.3c0-4.1 3.4-7.5 7.6-7.5 4.1 0 7.5 3.4 7.5 7.5v140.6l125.5 87.2 18.1-15.3c10.3-8.8 25.3-8.8 35.6 0l18.1 15.3 125.5-87.2v-231h-322.8v60.4c0 4.1-3.4 7.5-7.5 7.5-4.2 0-7.6-3.4-7.6-7.5v-67.9c0-4.1 3.4-7.5 7.6-7.5h337.8c4.2 0 7.6 3.4 7.6 7.5v151.2l54.2 46c1.6 1.4 2.6 3.6 2.6 5.8v106.1c0 4.1-3.3 7.5-7.5 7.5-4.2 0-7.5-3.4-7.5-7.5zm-442.9 188q0 0 0 0 0 0 0 0zm0.1 0c5.4 5 0.1 0.2-0.1 0q0.1 0 0.1 0zm11-294.7l37 25.7v-57.2zm418.9 287.1l-197.3-167.7c-4.7-3.9-11.5-3.9-16.2 0l-99.4 84.6c-3.2 2.6-7.9 2.3-10.6-0.9-2.7-3.2-2.3-7.9 0.9-10.6l69.5-59.1-170.5-118.4v259.6q0 1.7 0.4 3.4l77.7-66c3.1-2.7 7.9-2.3 10.6 0.8 2.7 3.2 2.3 7.9-0.9 10.6l-74.9 63.7zm8.1-287.1l-37-31.5v57.2z"
        />
      </g>
    </g>
    <path
      id="path1742"
      fill="#eb5569"
      d="m334.4 95.3c-17.7-17.7-46.5-17.7-64.2 0l-7 7c-4.1 4.1-10.6 4.1-14.7 0l-7-7c-17.7-17.7-46.5-17.7-64.2 0-17.7 17.7-17.7 46.5 0 64.2l66.6 66.7c6.6 6.5 17.3 6.5 23.9 0l66.6-66.7c17.7-17.7 17.7-46.5 0-64.2z"
    />
    <path
      id="path1758"
      fill="#e53950"
      d="m334.4 159.5l-66.7 66.7c-6.5 6.5-17.2 6.5-23.8 0l-12.8-12.9 56.6-56.6c17.7-17.8 17.7-46.5 0-64.2-1.8-1.9-3.8-3.7-6-5.6 17-8.7 38.4-5.9 52.7 8.4 17.7 17.7 17.7 46.5 0 64.2z"
    />
    <path
      id="path1770"
      fillRule="evenodd"
      fill="none"
      stroke="#000000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="20"
      d="m334.4 95.3c-17.7-17.7-46.5-17.7-64.2 0l-7 7c-4.1 4.1-10.6 4.1-14.7 0l-7-7c-17.7-17.7-46.5-17.7-64.2 0-17.7 17.7-17.7 46.5 0 64.2l66.6 66.7c6.6 6.5 17.3 6.5 23.9 0l66.6-66.7c17.7-17.7 17.7-46.5 0-64.2z"
    />
  </svg>
);

export const GoogleSVG = () => (
  <svg
    className="w-4 h-auto"
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
  >
    <path
      d="M46 24.0287C46 22.09 45.8533 20.68 45.5013 19.2112H23.4694V27.9356H36.4069C36.1429 30.1094 34.7347 33.37 31.5957 35.5731L31.5663 35.8669L38.5191 41.2719L38.9885 41.3306C43.4477 37.2181 46 31.1669 46 24.0287Z"
      fill="#4285F4"
    />
    <path
      d="M23.4694 47C29.8061 47 35.1161 44.9144 39.0179 41.3012L31.625 35.5437C29.6301 36.9244 26.9898 37.8937 23.4987 37.8937C17.2793 37.8937 12.0281 33.7812 10.1505 28.1412L9.88649 28.1706L2.61097 33.7812L2.52296 34.0456C6.36608 41.7125 14.287 47 23.4694 47Z"
      fill="#34A853"
    />
    <path
      d="M10.1212 28.1413C9.62245 26.6725 9.32908 25.1156 9.32908 23.5C9.32908 21.8844 9.62245 20.3275 10.0918 18.8588V18.5356L2.75765 12.8369L2.52296 12.9544C0.909439 16.1269 0 19.7106 0 23.5C0 27.2894 0.909439 30.8731 2.49362 34.0456L10.1212 28.1413Z"
      fill="#FBBC05"
    />
    <path
      d="M23.4694 9.07688C27.8699 9.07688 30.8622 10.9863 32.5344 12.5725L39.1645 6.11C35.0867 2.32063 29.8061 0 23.4694 0C14.287 0 6.36607 5.2875 2.49362 12.9544L10.0918 18.8588C11.9987 13.1894 17.25 9.07688 23.4694 9.07688Z"
      fill="#EB4335"
    />
  </svg>
);

export const ErrorSVG = () => (
  <svg
    className="size-5 text-red-500"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    aria-hidden="true"
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
  </svg>
);

export const DeleteSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-trash-2 flex-shrink-0"
  >
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
    <line x1="10" x2="10" y1="11" y2="17" />
    <line x1="14" x2="14" y1="11" y2="17" />
  </svg>
);

export const InviteSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-mail-open flex-shrink-0"
  >
    <path d="M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z" />
    <path d="m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10" />
  </svg>
);

export const EditSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-mail-open flex-shrink-0"
  >
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </svg>
);

export const PeopleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-mail-open flex-shrink-0"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const ActivateSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="20" height="14" x="2" y="5" rx="2" />
    <line x1="2" x2="22" y1="10" y2="10" />
  </svg>
);

export const ShareSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-mail-open flex-shrink-0"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
  </svg>
);

export const DissmissSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-x size-4"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export const ToggleNavigationSVG = () => (
  <svg
    className="size-5"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);
export const UploadImageSVG = () => (
  <svg
    className="size-10 mx-auto text-gray-400  "
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"
    />
    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
  </svg>
);
export const AccordionOpenSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 15l7-7 7 7"
    />
  </svg>
);

export const AccordionClosedSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

export const DefaultAvatarSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-full"
  >
    <path d="M18 20a6 6 0 0 0-12 0" />
    <circle cx="12" cy="10" r="4" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);

export const PencilSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-pencil"
  >
    <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
    <path d="m15 5 4 4" />
  </svg>
);

export const StarRating = () => (
  <svg
    className="flex-shrink-0 size-5"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path>
  </svg>
);

export const PencilOffSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-pencil-off"
  >
    <path d="m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982" />
    <path d="m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353" />
    <path d="m15 5 4 4" />
    <path d="m2 2 20 20" />
  </svg>
);

export const CheckmarkSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-circle-check"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

export const NavbarBurgerMenu = () => (
  <svg
    className="hs-collapse-open:hidden flex-shrink-0 size-4"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" x2="21" y1="6" y2="6" />
    <line x1="3" x2="21" y1="12" y2="12" />
    <line x1="3" x2="21" y1="18" y2="18" />
  </svg>
);

export const NavbarBurgerMenuOpen = () => (
  <svg
    className="hs-collapse-open:block hidden flex-shrink-0 size-4"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);

export const TopRightArrowSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-square-arrow-out-up-right scale-[0.6]"
  >
    <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
    <path d="m21 3-9 9" />
    <path d="M15 3h6v6" />
  </svg>
);

export const FeaturesDesignSVG = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m268.968 323.6c-7.477-6.355-18.459-6.355-25.936 0l-206.467 175.475c3.579 3.346 8.373 5.41 13.659 5.41h411.552c5.286 0 10.08-2.064 13.659-5.41z"
        fill="#ffdc00"
      />
      <path
        d="m291.447 342.705 183.988 156.37c3.908-3.655 6.366-8.842 6.366-14.615v-273.997z"
        fill="#ffce00"
      />
      <path
        d="m36.565 499.075 183.988-156.37-190.354-132.242v273.997c0 5.774 2.458 10.961 6.366 14.615z"
        fill="#ffce00"
      />
      <path
        d="m36.565 499.075 183.988-156.37-11.658-8.099-178.598 151.79c.482 4.991 2.802 9.438 6.268 12.679z"
        fill="#fbbd00"
      />
      <path
        d="m475.435 499.075-183.988-156.37 11.658-8.099 178.599 151.79c-.483 4.991-2.803 9.438-6.269 12.679z"
        fill="#fbbd00"
      />
      <path d="m87.061 162.137v87.829l-56.862-39.503z" fill="#ff7e00" />
      <path
        d="m30.199 210.463 56.862 39.503v-18.022l-45.194-31.397z"
        fill="#ff6700"
      />
      <path d="m424.939 162.137v87.829l56.862-39.503z" fill="#ff7e00" />
      <path
        d="m424.939 231.944v18.022l56.862-39.503-11.668-9.916z"
        fill="#ff6700"
      />
      <path
        d="m220.553 342.705 22.479-19.104c7.477-6.355 18.459-6.355 25.936 0l22.479 19.104 133.492-92.739v-242.451h-337.878v242.451z"
        fill="#fff0c0"
      />
      <path
        d="m291.447 324.683-22.479-19.104c-7.478-6.355-18.459-6.355-25.936 0l-22.479 19.104-133.492-92.739v18.022l133.492 92.739 22.479-19.104c7.477-6.355 18.459-6.355 25.936 0l22.479 19.104 133.492-92.739v-18.022z"
        fill="#ffe394"
      />
      <path
        d="m267.644 89.122 16.561 27.921c1.901 3.205 5.039 5.484 8.674 6.302l31.672 7.122c10.03 2.256 13.985 14.428 7.197 22.148l-21.437 24.378c-2.46 2.798-3.659 6.487-3.313 10.197l3.014 32.322c.954 10.237-9.4 17.759-18.841 13.689l-29.809-12.854c-3.422-1.475-7.3-1.475-10.722 0l-29.809 12.854c-9.44 4.071-19.795-3.452-18.841-13.689l3.014-32.322c.346-3.71-.853-7.399-3.313-10.197l-21.437-24.378c-6.789-7.72-2.834-19.893 7.196-22.148l31.672-7.122c3.635-.817 6.773-3.097 8.674-6.302l16.561-27.921c5.244-8.842 18.042-8.842 23.287 0z"
        fill="#ffdc00"
      />
      <g>
        <path
          d="m308.953 208.162c-2.828 6.466-10.569 10.128-17.783 7.017l-29.809-12.854c-3.422-1.475-7.3-1.475-10.722 0l-29.809 12.854c-7.213 3.11-14.954-.551-17.782-7.017l-1.058 11.351c-.954 10.237 9.4 17.759 18.841 13.689l29.809-12.854c3.422-1.475 7.3-1.475 10.722 0l29.809 12.854c9.441 4.071 19.795-3.452 18.841-13.689z"
          fill="#ffbf00"
        />
      </g>
      <g>
        <path d="m481.8 324.086c4.151 0 7.515-3.364 7.515-7.515v-106.108c0-2.176-.989-4.318-2.648-5.726l-54.214-46.076v-151.146c0-4.151-3.364-7.515-7.515-7.515h-337.876c-4.151 0-7.515 3.364-7.515 7.515v67.875c0 4.151 3.364 7.515 7.515 7.515s7.515-3.364 7.515-7.515v-60.361h322.847v231.007l-125.516 87.198-18.073-15.36c-10.335-8.783-25.335-8.783-35.669 0l-18.073 15.36-125.517-87.198v-140.587c0-4.151-3.364-7.515-7.515-7.515s-7.515 3.364-7.515 7.515v53.212l-54.214 46.076c-1.659 1.408-2.648 3.55-2.648 5.726v273.998c0 7.577 3.188 14.905 8.747 20.103s0 0 .001.001c5.129 4.794 11.803 7.435 18.792 7.435h411.552c6.989 0 13.663-2.641 18.792-7.435 0 0 0-.001.001-.001 5.559-5.198 8.747-12.525 8.747-20.103v-137.831c0-4.151-3.364-7.515-7.515-7.515s-7.515 3.364-7.515 7.515v137.831c0 1.16-.171 2.288-.475 3.371l-170.056-144.528 170.531-118.47v91.738c0 4.15 3.364 7.514 7.514 7.514zm-402.253-145.7v57.209l-37.038-25.731zm-28.902 318.585 74.922-63.675c3.163-2.688 3.547-7.431.859-10.593-2.687-3.16-7.428-3.547-10.593-.859l-77.644 65.989c-.304-1.084-.475-2.212-.475-3.371v-259.628l170.531 118.47-69.508 59.074c-3.162 2.688-3.547 7.431-.859 10.593 2.687 3.161 7.43 3.548 10.593.859l99.429-84.503c4.693-3.99 11.509-3.99 16.202 0l197.254 167.644zm381.808-261.376v-57.209l37.038 31.478z" />
        <path d="m337.389 157.578c4.959-5.639 6.533-13.269 4.213-20.409-2.32-7.141-8.078-12.387-15.403-14.034l-31.673-7.122c-1.61-.362-3.017-1.383-3.859-2.803l-16.56-27.921c-3.831-6.458-10.6-10.313-18.108-10.313s-14.277 3.855-18.107 10.313l-16.561 27.92c-.842 1.421-2.249 2.442-3.86 2.804l-31.672 7.122c-7.325 1.647-13.083 6.893-15.403 14.034-2.32 7.14-.746 14.77 4.213 20.408l21.435 24.377c1.09 1.241 1.628 2.895 1.474 4.538l-3.014 32.323c-.697 7.477 2.514 14.573 8.588 18.987 6.074 4.412 13.817 5.273 20.71 2.299l29.809-12.854c1.517-.654 3.254-.654 4.771 0l29.809 12.854c6.805 2.935 14.716 2.055 20.71-2.299 6.074-4.414 9.285-11.511 8.588-18.987l-3.014-32.322c-.154-1.644.385-3.298 1.474-4.538zm-32.723 14.454c-3.809 4.333-5.686 10.111-5.152 15.855l3.014 32.323c.419 4.491-4.225 7.878-8.383 6.091l-29.809-12.854c-5.27-2.273-11.403-2.274-16.673 0l-29.809 12.854c-4.157 1.787-8.802-1.599-8.383-6.091l3.014-32.324c.534-5.744-1.342-11.521-5.153-15.856l-21.436-24.378c-2.989-3.399-1.198-8.865 3.201-9.854l31.671-7.122c5.629-1.265 10.545-4.837 13.489-9.799l16.562-27.921c2.31-3.896 8.048-3.874 10.361 0l16.561 27.922c2.944 4.962 7.86 8.533 13.488 9.798l31.672 7.122c4.399.989 6.19 6.455 3.202 9.854z" />
      </g>
    </g>
  </svg>
);

export const FeaturesListSVG = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m411.165 49.053c10.754 0 19.472 8.718 19.472 19.472v416.495c0 10.754-8.718 19.472-19.472 19.472h-310.33c-10.754 0-19.472-8.718-19.472-19.472v-416.495c0-10.754 8.718-19.472 19.472-19.472z"
        fill="#e8834d"
      />
      <path
        d="m411.165 486.474h-310.33c-10.754 0-19.472-8.718-19.472-19.472v18.018c0 10.754 8.718 19.472 19.472 19.472h310.331c10.754 0 19.472-8.718 19.472-19.472v-18.018c-.001 10.754-8.719 19.472-19.473 19.472z"
        fill="#d56723"
      />
      <path d="m117.001 85.11h277.997v383.325h-277.997z" fill="#fff0c0" />
      <path d="m117.001 450.417h277.997v18.018h-277.997z" fill="#ffe394" />
      <path
        d="m185.761 195.082h-25.605c-5.528 0-10.01-4.482-10.01-10.01v-25.605c0-5.528 4.482-10.01 10.01-10.01h25.605c5.529 0 10.01 4.482 10.01 10.01v25.605c0 5.528-4.482 10.01-10.01 10.01z"
        fill="#00e0a7"
      />
      <path
        d="m185.761 177.063h-25.605c-5.528 0-10.01-4.482-10.01-10.01v18.018c0 5.528 4.482 10.01 10.01 10.01h25.605c5.529 0 10.01-4.482 10.01-10.01v-18.018c0 5.529-4.482 10.01-10.01 10.01z"
        fill="#00c988"
      />
      <path
        d="m185.761 271.539h-25.605c-5.528 0-10.01-4.482-10.01-10.01v-25.605c0-5.528 4.482-10.01 10.01-10.01h25.605c5.529 0 10.01 4.482 10.01 10.01v25.605c0 5.529-4.482 10.01-10.01 10.01z"
        fill="#00e0a7"
      />
      <path
        d="m185.761 253.521h-25.605c-5.528 0-10.01-4.482-10.01-10.01v18.018c0 5.528 4.482 10.01 10.01 10.01h25.605c5.529 0 10.01-4.482 10.01-10.01v-18.018c0 5.528-4.482 10.01-10.01 10.01z"
        fill="#00c988"
      />
      <path
        d="m185.761 347.997h-25.605c-5.528 0-10.01-4.482-10.01-10.01v-25.605c0-5.528 4.482-10.01 10.01-10.01h25.605c5.529 0 10.01 4.482 10.01 10.01v25.605c0 5.529-4.482 10.01-10.01 10.01z"
        fill="#00e0a7"
      />
      <path
        d="m185.761 329.979h-25.605c-5.528 0-10.01-4.482-10.01-10.01v18.018c0 5.528 4.482 10.01 10.01 10.01h25.605c5.529 0 10.01-4.482 10.01-10.01v-18.018c0 5.528-4.482 10.01-10.01 10.01z"
        fill="#00c988"
      />
      <path
        d="m185.761 424.455h-25.605c-5.528 0-10.01-4.482-10.01-10.01v-25.605c0-5.529 4.482-10.01 10.01-10.01h25.605c5.529 0 10.01 4.482 10.01 10.01v25.605c0 5.528-4.482 10.01-10.01 10.01z"
        fill="#00e0a7"
      />
      <path
        d="m185.761 406.437h-25.605c-5.528 0-10.01-4.482-10.01-10.01v18.018c0 5.528 4.482 10.01 10.01 10.01h25.605c5.529 0 10.01-4.482 10.01-10.01v-18.018c0 5.528-4.482 10.01-10.01 10.01z"
        fill="#00c988"
      />
      <path
        d="m322.232 36.262h-32.399v-18.575c0-5.622-4.557-10.179-10.179-10.179h-47.308c-5.622 0-10.179 4.557-10.179 10.179v18.576h-32.4c-7.084 0-12.826 5.743-12.826 12.826v35.303c0 7.084 5.743 12.826 12.826 12.826h42.579 47.308 42.579c7.084 0 12.826-5.743 12.826-12.826v-35.304c0-7.083-5.743-12.826-12.827-12.826z"
        fill="#ffdc00"
      />
      <path
        d="m322.232 79.2h-42.579-47.308-42.579c-7.084 0-12.826-5.743-12.826-12.826v18.018c0 7.084 5.743 12.826 12.826 12.826h42.579 47.308 42.579c7.084 0 12.826-5.743 12.826-12.826v-18.019c.001 7.084-5.742 12.827-12.826 12.827z"
        fill="#ffbf00"
      />
      <g>
        <path d="m430.638 233.422c-4.147 0-7.508 3.361-7.508 7.508v244.091c0 6.597-5.367 11.964-11.964 11.964h-310.332c-6.597 0-11.964-5.367-11.964-11.964v-311.225c0-4.146-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v311.224c0 14.877 12.103 26.979 26.98 26.979h310.332c14.876 0 26.98-12.103 26.98-26.979v-244.091c0-4.146-3.361-7.507-7.508-7.507z" />
        <path d="m142.638 337.987c0 9.659 7.859 17.518 17.518 17.518h25.605c9.659 0 17.518-7.859 17.518-17.518v-25.605c0-9.659-7.859-17.518-17.518-17.518h-25.605c-9.659 0-17.518 7.859-17.518 17.518zm15.015-25.605c0-1.38 1.122-2.503 2.503-2.503h25.605c1.38 0 2.503 1.123 2.503 2.503v25.605c0 1.38-1.122 2.503-2.503 2.503h-25.605c-1.38 0-2.503-1.123-2.503-2.503z" />
        <path d="m411.166 41.546h-70.066c-3.004-7.485-10.321-12.792-18.867-12.792h-24.893v-11.067c0-9.753-7.934-17.687-17.686-17.687h-47.308c-9.752 0-17.686 7.934-17.686 17.687v11.068h-24.893c-8.546 0-15.863 5.306-18.867 12.792h-70.066c-14.876 0-26.98 12.103-26.98 26.979v75.24c0 4.146 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-75.24c0-6.597 5.367-11.964 11.964-11.964h68.6v21.041h-52.433c-4.147 0-7.508 3.361-7.508 7.508v288.028c0 4.146 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-280.521h46.679c3.166 7.122 10.296 12.108 18.579 12.108h132.466c8.283 0 15.412-4.986 18.579-12.108h46.679v368.309h-262.982v-57.758c0-4.146-3.361-7.508-7.508-7.508s-7.508 3.361-7.508 7.508v65.266c0 4.146 3.361 7.508 7.508 7.508h277.998c4.147 0 7.508-3.361 7.508-7.508v-383.324c0-4.146-3.361-7.508-7.508-7.508h-52.433v-21.042h68.6c6.598 0 11.964 5.367 11.964 11.964v142.373c0 4.146 3.361 7.508 7.508 7.508s7.508-3.361 7.508-7.508v-142.373c0-14.876-12.104-26.979-26.98-26.979zm-83.615 42.846c0 2.933-2.385 5.319-5.318 5.319h-132.466c-2.933 0-5.318-2.386-5.318-5.319v-35.304c0-2.933 2.385-5.319 5.318-5.319h32.4c4.147 0 7.508-3.361 7.508-7.508v-18.574c0-1.473 1.199-2.671 2.671-2.671h47.308c1.472 0 2.671 1.198 2.671 2.671v18.576c0 4.146 3.361 7.508 7.508 7.508h32.4c2.933 0 5.318 2.386 5.318 5.319z" />
        <path d="m160.156 202.59h25.605c9.659 0 17.518-7.859 17.518-17.518v-25.605c0-9.659-7.859-17.518-17.518-17.518h-25.605c-9.659 0-17.518 7.859-17.518 17.518v25.605c0 9.659 7.858 17.518 17.518 17.518zm-2.503-43.123c0-1.38 1.122-2.503 2.503-2.503h25.605c1.38 0 2.503 1.123 2.503 2.503v25.605c0 1.38-1.122 2.503-2.503 2.503h-25.605c-1.38 0-2.503-1.123-2.503-2.503z" />
        <path d="m230.577 166.288h126.349c4.147 0 7.508-3.361 7.508-7.508 0-4.146-3.361-7.508-7.508-7.508h-126.349c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
        <path d="m230.577 193.265h71.014c4.147 0 7.508-3.361 7.508-7.508 0-4.146-3.361-7.508-7.508-7.508h-71.014c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
        <path d="m142.638 261.529c0 9.659 7.859 17.518 17.518 17.518h25.605c9.659 0 17.518-7.859 17.518-17.518v-25.605c0-9.659-7.859-17.518-17.518-17.518h-25.605c-9.659 0-17.518 7.859-17.518 17.518zm15.015-25.605c0-1.38 1.122-2.503 2.503-2.503h25.605c1.38 0 2.503 1.123 2.503 2.503v25.605c0 1.38-1.122 2.503-2.503 2.503h-25.605c-1.38 0-2.503-1.123-2.503-2.503z" />
        <path d="m230.577 242.746h126.349c4.147 0 7.508-3.361 7.508-7.508s-3.361-7.508-7.508-7.508h-126.349c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
        <path d="m230.577 269.723h71.014c4.147 0 7.508-3.361 7.508-7.508 0-4.146-3.361-7.508-7.508-7.508h-71.014c-4.147 0-7.508 3.361-7.508 7.508 0 4.146 3.361 7.508 7.508 7.508z" />
        <path d="m230.577 319.204h126.349c4.147 0 7.508-3.361 7.508-7.508s-3.361-7.508-7.508-7.508h-126.349c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
        <path d="m230.577 346.18h71.014c4.147 0 7.508-3.361 7.508-7.508 0-4.146-3.361-7.508-7.508-7.508h-71.014c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
        <path d="m142.638 414.444c0 9.659 7.859 17.518 17.518 17.518h25.605c9.659 0 17.518-7.859 17.518-17.518v-25.604c0-9.659-7.859-17.518-17.518-17.518h-25.605c-9.659 0-17.518 7.859-17.518 17.518zm15.015-25.604c0-1.38 1.122-2.503 2.503-2.503h25.605c1.38 0 2.503 1.123 2.503 2.503v25.605c0 1.38-1.122 2.503-2.503 2.503h-25.605c-1.38 0-2.503-1.123-2.503-2.503z" />
        <path d="m230.577 395.662h126.349c4.147 0 7.508-3.361 7.508-7.508s-3.361-7.508-7.508-7.508h-126.349c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
        <path d="m230.577 422.638h71.014c4.147 0 7.508-3.361 7.508-7.508 0-4.146-3.361-7.508-7.508-7.508h-71.014c-4.147 0-7.508 3.361-7.508 7.508s3.361 7.508 7.508 7.508z" />
      </g>
    </g>
  </svg>
);

export const FeaturesMegaphoneSVG = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m152.426 278.073c-9.041-.609-18.316-.937-27.822-.937v70.656c16.174-3.2 27.308-9.003 34.609-14.38 6.996-5.153 8.924-14.791 4.632-22.346-6.095-10.729-9.55-23.639-11.419-32.993z"
        fill="#56555b"
      />
      <path
        d="m101.886 463.166c-12.547 0-22.718-10.171-22.718-22.718v-163.312h45.436v163.312c0 12.547-10.171 22.718-22.718 22.718z"
        fill="#cac0c9"
      />
      <path
        d="m124.604 151.711v125.425h-90.902c-14.463 0-26.187-11.725-26.187-26.187v-73.051c0-14.463 11.725-26.187 26.187-26.187z"
        fill="#ff2f6b"
      />
      <path
        d="m7.515 232.914v18.035c0 14.463 11.725 26.187 26.187 26.187h90.902v-18.035h-90.902c-14.463 0-26.187-11.724-26.187-26.187z"
        fill="#f3155e"
      />
      <path
        d="m366.956 357.295s-93.05-80.159-242.352-80.159v-125.425c149.302 0 242.352-80.159 242.352-80.159z"
        fill="#e6e2e6"
      />
      <path
        d="m124.604 277.136c149.302 0 242.352 80.159 242.352 80.159v-27.053s-93.05-71.141-242.352-71.141z"
        fill="#d8d1d7"
      />
      <path
        d="m389.674 380.013c-12.547 0-22.718-10.171-22.718-22.718v-285.743c0-12.547 10.171-22.718 22.718-22.718 12.547 0 22.718 10.171 22.718 22.718v285.743c0 12.547-10.171 22.718-22.718 22.718z"
        fill="#ffdc00"
      />
      <path
        d="m389.674 361.978c-12.547 0-22.718-10.171-22.718-22.718v18.035c0 12.547 10.171 22.718 22.718 22.718s22.718-10.171 22.718-22.718v-18.035c0 12.547-10.171 22.718-22.718 22.718z"
        fill="#ffbf00"
      />
      <path
        d="m168.445 149.372c-14.007 1.495-28.626 2.339-43.84 2.339v125.425c15.214 0 29.833.844 43.84 2.339z"
        fill="#ffdc00"
      />
      <path d="m79.168 277.136h45.436v18.035h-45.436z" fill="#bbb0ba" />
      <path
        d="m157.369 296.48c-2.293-6.583-3.877-13.073-4.943-18.407-9.041-.609-18.316-.937-27.822-.937v18.035c11.25 0 22.172.465 32.765 1.309z"
        fill="#434347"
      />
      <path
        d="m124.604 259.101v18.035c15.214 0 29.833.844 43.84 2.339v-18.298c-14.006-1.327-28.626-2.076-43.84-2.076z"
        fill="#ffbf00"
      />
      <g>
        <path d="m389.674 41.319c-15.394 0-28.129 11.568-29.99 26.466-6.791 5.381-28.029 21.231-61.157 37.066-37.551 17.949-98.206 39.345-173.923 39.345h-90.902c-18.583 0-33.702 15.119-33.702 33.702v73.05c0 18.583 15.119 33.702 33.702 33.702h37.951v70.471c0 4.15 3.365 7.515 7.515 7.515s7.515-3.365 7.515-7.515v-70.471h30.407v155.797c0 8.383-6.82 15.204-15.203 15.204s-15.203-6.82-15.203-15.204v-55.268c0-4.15-3.365-7.515-7.515-7.515s-7.515 3.364-7.515 7.515v55.268c0 16.67 13.563 30.233 30.233 30.233s30.233-13.563 30.233-30.233v-86.65c12.199-3.08 22.794-7.886 31.551-14.335 10.028-7.386 12.912-21.19 6.709-32.109-3.725-6.558-6.388-14.105-8.262-20.934 58.048 5.447 104.884 22.56 135.908 37.335 33.301 15.859 54.811 31.895 61.661 37.312 1.863 14.895 14.597 26.461 29.989 26.461 16.67 0 30.233-13.563 30.233-30.233v-207.724c0-4.15-3.364-7.515-7.515-7.515s-7.515 3.365-7.515 7.515v207.725c0 8.383-6.82 15.203-15.203 15.203s-15.204-6.82-15.204-15.203v-285.743c0-8.383 6.82-15.204 15.204-15.204 8.383 0 15.203 6.82 15.203 15.204v47.959c0 4.15 3.365 7.515 7.515 7.515s7.515-3.364 7.515-7.515v-47.959c-.002-16.67-13.565-30.233-30.235-30.233zm-272.584 228.302h-83.388c-10.296 0-18.673-8.377-18.673-18.673v-73.05c0-10.296 8.377-18.673 18.673-18.673h83.387v110.396zm37.667 57.741c-6.311 4.648-13.9 8.285-22.638 10.862v-53.499c4.793.09 9.52.266 14.185.519 2.129 8.957 5.58 19.981 11.008 29.534 2.443 4.302 1.345 9.712-2.555 12.584zm21.202-54.551v-43.358c0-4.15-3.365-7.515-7.515-7.515s-7.515 3.364-7.515 7.515v41.761c-9.336-.817-18.943-1.345-28.811-1.523v-110.535c9.868-.178 19.475-.706 28.811-1.523v41.761c0 4.15 3.365 7.515 7.515 7.515s7.515-3.364 7.515-7.515v-43.358c54.711-6.793 99.011-23.267 129.049-37.625 24.915-11.909 43.306-23.758 54.432-31.671v255.367c-11.126-7.913-29.518-19.763-54.432-31.672-30.037-14.357-74.338-30.831-129.049-37.624z" />
        <path d="m504.485 206.909h-40.464c-4.15 0-7.515 3.365-7.515 7.515s3.364 7.515 7.515 7.515h40.464c4.15 0 7.515-3.365 7.515-7.515s-3.365-7.515-7.515-7.515z" />
        <path d="m456.656 258.319c-2.663-3.184-7.403-3.606-10.585-.942-3.183 2.663-3.605 7.402-.942 10.585l25.963 31.037c2.626 3.14 7.444 3.571 10.585.942 3.184-2.663 3.605-7.402.942-10.585z" />
        <path d="m446.071 171.471c3.141 2.628 7.96 2.198 10.585-.942l25.963-31.037c2.663-3.183 2.241-7.922-.942-10.585-3.182-2.664-7.922-2.242-10.585.942l-25.963 31.037c-2.663 3.183-2.241 7.922.942 10.585z" />
      </g>
    </g>
  </svg>
);

export const FeaturesTableSVG = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m410.068 333.603v75.302c0 11.383 9.228 20.611 20.611 20.611 11.383 0 20.611-9.228 20.611-20.611v-79.228c-13.072 5.601-27.509 6.909-41.222 3.926z"
        fill="#e8834d"
      />
      <path
        d="m60.71 329.677v79.228c0 11.383 9.228 20.611 20.611 20.611 11.383 0 20.611-9.228 20.611-20.611v-75.302c-13.713 2.983-28.15 1.675-41.222-3.926z"
        fill="#e8834d"
      />
      <path
        d="m451.521 96.375 51.743 172.36c3.349 11.155-.452 23.223-9.589 30.446l-26.999 21.344c-24.697 19.524-59.573 19.524-84.27 0-24.698-19.524-59.573-19.524-84.271 0-24.697 19.524-59.573 19.524-84.27 0-24.697-19.524-59.573-19.524-84.27 0-24.697 19.524-59.573 19.524-84.27 0l-26.999-21.344c-9.136-7.223-12.937-19.291-9.589-30.446l51.743-172.36c2.475-8.245 10.065-13.891 18.673-13.891h353.695c8.608 0 16.198 5.646 18.673 13.891z"
        fill="#ff2f6b"
      />
      <path
        d="m60.71 329.677v20.74c13.073 5.601 27.51 6.909 41.222 3.925v-20.74c-13.713 2.984-28.15 1.676-41.222-3.925z"
        fill="#d56723"
      />
      <path
        d="m451.29 350.417v-20.74c-13.073 5.6-27.51 6.909-41.222 3.925v20.74c13.713 2.984 28.15 1.676 41.222-3.925z"
        fill="#d56723"
      />
      <path
        d="m502.995 267.839c-1.711 5.139-4.879 9.798-9.32 13.309l-26.999 21.344c-24.697 19.525-59.573 19.525-84.27 0-24.698-19.524-59.573-19.524-84.271 0-24.697 19.525-59.573 19.525-84.27 0-24.697-19.524-59.573-19.524-84.27 0-24.697 19.525-59.573 19.525-84.27 0l-26.999-21.344c-4.441-3.51-7.608-8.17-9.32-13.309l-.269.896c-3.349 11.155.452 23.223 9.589 30.446l26.999 21.344c24.697 19.525 59.573 19.525 84.27 0 24.697-19.524 59.573-19.524 84.27 0 24.698 19.525 59.573 19.525 84.27 0 24.698-19.524 59.573-19.524 84.271 0 24.697 19.525 59.573 19.525 84.27 0l26.999-21.344c9.136-7.223 12.937-19.291 9.589-30.446z"
        fill="#f3155e"
      />
      <path
        d="m433.329 176.143c0-1.428.108-2.83.309-4.201-6.262 8.142-30.851 35.89-75.201 35.89-41.652 0-65.875-24.475-73.855-34.198.072.828.116 1.663.116 2.51 0 10.848-6.021 20.288-14.902 25.167 15.715 23.363 45.004 54.897 88.641 54.897 43.936 0 73.326-31.967 88.961-55.375-8.421-5.002-14.069-14.185-14.069-24.69z"
        fill="#ffdc00"
      />
      <path
        d="m439.41 193.793c-16.814 21.299-43.639 44.38-80.973 44.38-36.914 0-63.559-22.566-80.406-43.662-2.292 2.745-5.078 5.065-8.235 6.799 15.715 23.363 45.004 54.897 88.641 54.897 43.936 0 73.326-31.967 88.961-55.375-3.083-1.832-5.789-4.228-7.988-7.039z"
        fill="#ffbf00"
      />
      <ellipse
        cx="256"
        cy="176.143"
        fill="#fff0c0"
        rx="28.697"
        ry="28.698"
        transform="matrix(.953 -.304 .304 .953 -41.446 86.209)"
      />
      <path
        d="m227.303 176.143c0-.846.044-1.682.116-2.51-7.98 9.723-32.203 34.198-73.855 34.198-44.35 0-68.94-27.747-75.201-35.89.201 1.372.309 2.774.309 4.201 0 10.505-5.647 19.687-14.069 24.688 15.635 23.408 45.026 55.375 88.961 55.375 43.637 0 72.926-31.534 88.641-54.897-8.882-4.877-14.902-14.317-14.902-25.165z"
        fill="#ffdc00"
      />
      <path
        d="m233.969 194.511c-16.848 21.096-43.492 43.662-80.407 43.662-37.334 0-64.159-23.081-80.973-44.38-2.199 2.811-4.905 5.208-7.988 7.039 15.635 23.409 45.026 55.375 88.961 55.375 43.637 0 72.926-31.534 88.641-54.897-3.156-1.734-5.941-4.054-8.234-6.799z"
        fill="#ffbf00"
      />
      <ellipse
        cx="49.973"
        cy="176.143"
        fill="#fff0c0"
        rx="28.698"
        ry="28.698"
        transform="matrix(.707 -.707 .707 .707 -109.915 86.928)"
      />
      <ellipse
        cx="462.027"
        cy="176.143"
        fill="#fff0c0"
        rx="28.698"
        ry="28.697"
        transform="matrix(.379 -.925 .925 .379 123.777 536.813)"
      />
      <g fill="#ffe394">
        <path d="m256 186.807c-12.698 0-23.462-8.251-27.244-19.681-.938 2.837-1.454 5.866-1.454 9.017 0 15.849 12.848 28.698 28.697 28.698s28.697-12.848 28.697-28.698c0-3.151-.515-6.18-1.454-9.017-3.78 11.431-14.544 19.681-27.242 19.681z" />
        <path d="m49.973 186.807c-12.698 0-23.463-8.251-27.244-19.681-.938 2.837-1.454 5.866-1.454 9.017 0 15.849 12.848 28.698 28.698 28.698 15.849 0 28.697-12.848 28.697-28.698 0-3.151-.515-6.18-1.454-9.017-3.78 11.431-14.545 19.681-27.243 19.681z" />
        <path d="m462.027 186.807c-12.698 0-23.462-8.251-27.244-19.681-.938 2.837-1.454 5.866-1.454 9.017 0 15.849 12.848 28.698 28.697 28.698s28.698-12.848 28.698-28.698c0-3.151-.515-6.18-1.454-9.017-3.781 11.431-14.545 19.681-27.243 19.681z" />
      </g>
      <path d="m510.46 266.574-20.31-67.654c5.052-6.226 8.088-14.152 8.088-22.777 0-16.162-10.644-29.882-25.29-34.525l-14.231-47.404c-3.456-11.511-13.852-19.244-25.87-19.244h-75.719c-4.15 0-7.514 3.364-7.514 7.514s3.364 7.514 7.514 7.514h75.719c5.331 0 9.943 3.43 11.477 8.536l12.54 41.77c-15.093 2.165-27.211 13.667-30.289 28.45-7.314 8.973-29.58 31.563-68.138 31.563-36.081 0-57.861-19.698-66.669-29.825-2.721-17.293-17.723-30.562-35.768-30.562s-33.047 13.269-35.768 30.563c-8.809 10.126-30.589 29.824-66.669 29.824-38.576 0-60.844-22.611-68.148-31.575-3.083-14.774-15.191-26.273-30.279-28.437l12.54-41.771c1.533-5.106 6.145-8.536 11.477-8.536h247.92c4.15 0 7.514-3.364 7.514-7.514s-3.364-7.514-7.514-7.514h-247.921c-12.018 0-22.414 7.733-25.87 19.244l-14.231 47.404c-14.645 4.644-25.29 18.364-25.29 34.525 0 8.625 3.036 16.551 8.088 22.777l-20.309 67.654c-4.262 14.195.497 29.308 12.125 38.502l26.999 21.344c3.97 3.139 8.173 5.81 12.532 8.044v74.442c0 15.508 12.617 28.125 28.125 28.125s28.125-12.616 28.125-28.125v-69.452c8.794-2.694 17.217-7.032 24.809-13.033 22.066-17.445 52.886-17.444 74.95 0 27.552 21.78 66.038 21.779 93.591 0 10.628-8.403 23.932-13.024 37.482-13.024.073 0 .144.003.22 0 4.138 0 7.5-3.348 7.514-7.49.014-4.149-3.34-7.525-7.49-7.538-.082 0-.161 0-.243 0-16.917 0-33.531 5.771-46.803 16.263-22.065 17.443-52.885 17.443-74.95 0-27.553-21.78-66.038-21.782-93.59 0-22.066 17.444-52.886 17.444-74.951 0l-26.999-21.343c-6.762-5.347-9.531-14.137-7.052-22.392l18.613-62c8.552 4.045 18.554 4.548 27.472 1.392 12.562 17.434 32.252 38.137 59.392 47.856 4.063 1.457 8.628-.924 9.777-5.076 1.036-3.74-1.059-7.764-4.71-9.072-23.135-8.285-40.35-26.181-51.61-41.592 3.963-3.758 7.081-8.396 9.03-13.604 13.183 11.883 36.221 26.546 69.665 26.546 32.738 0 55.454-13.959 68.82-25.768 2.08 5.185 5.318 9.784 9.404 13.465-27.56 37.522-57.51 45.65-78.224 45.65-4.15 0-7.514 3.364-7.514 7.514s3.364 7.514 7.514 7.514c21.069 0 40.998-6.776 59.233-20.14 11.671-8.554 22.441-19.634 32.083-32.98 7.192 2.327 15.05 2.327 22.242 0 9.641 13.346 20.412 24.426 32.083 32.98 18.235 13.364 38.164 20.14 59.233 20.14 21.196 0 41.233-6.856 59.555-20.378 11.644-8.593 22.383-19.697 31.989-33.055 8.919 3.156 18.921 2.653 27.473-1.392l18.613 62c2.479 8.256-.29 17.046-7.052 22.391l-26.999 21.344c-22.065 17.441-52.886 17.443-74.951 0-4.344-3.433-9.063-6.389-14.027-8.783-3.738-1.802-8.229-.234-10.032 3.503-1.803 3.738-.235 8.229 3.503 10.032 3.975 1.918 7.755 4.285 11.237 7.038 7.591 6.001 16.014 10.339 24.808 13.033v69.452c0 15.508 12.617 28.125 28.125 28.125s28.125-12.616 28.125-28.125v-74.442c4.359-2.234 8.561-4.905 12.532-8.044l26.999-21.345c11.628-9.194 16.387-24.306 12.125-38.502zm-442.236 73.662c6.303 1.671 12.768 2.519 19.235 2.519 2.322 0 4.644-.12 6.959-.335v66.485c0 7.221-5.875 13.097-13.097 13.097-7.221 0-13.097-5.875-13.097-13.097zm-18.251-142.909c-11.681 0-21.184-9.503-21.184-21.183 0-11.681 9.503-21.184 21.184-21.184s21.184 9.503 21.184 21.184c0 11.68-9.503 21.183-21.184 21.183zm206.027 0c-11.68 0-21.184-9.503-21.184-21.183 0-11.681 9.503-21.184 21.184-21.184s21.183 9.503 21.183 21.184c0 11.68-9.502 21.183-21.183 21.183zm102.437 51.365c-20.714 0-50.664-8.128-78.224-45.65 4.086-3.682 7.325-8.28 9.404-13.465 13.366 11.81 36.082 25.769 68.82 25.769 33.444 0 56.482-14.663 69.665-26.546 1.949 5.207 5.066 9.844 9.028 13.602-27.666 38.057-57.83 46.29-78.693 46.29zm103.59-51.365c-11.681 0-21.184-9.503-21.184-21.183 0-11.681 9.503-21.184 21.184-21.184 11.68 0 21.183 9.503 21.183 21.184 0 11.68-9.503 21.183-21.183 21.183zm-18.251 211.578c0 7.221-5.875 13.097-13.097 13.097s-13.097-5.875-13.097-13.097v-66.485c8.784.817 17.666.077 26.194-2.184z" />
    </g>
  </svg>
);
export const SuccessPaymentSVG = () => (
  <svg
    width="100%"
    viewBox="0 0 500 319.767"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="coolGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fa0505" />
        <stop offset="100%" stopColor="#0ea5e9" />
      </linearGradient>
      <linearGradient id="warmGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#ff7e00" />
        <stop offset="100%" stopColor="#ffe600" />
      </linearGradient>
      <linearGradient id="greenGradient" x1="100%" y1="0%" x2="0%" y2="100%">
        <stop offset="10%" stopColor="#076324" />
        <stop offset="90%" stopColor="#4dff88" />
      </linearGradient>
      <linearGradient id="purpleGradient" x1="100%" y1="100%" x2="0%" y2="0%">
        <stop offset="10%" stopColor="#6a0dad" />
        <stop offset="90%" stopColor="#d8b0ff" />
      </linearGradient>
    </defs>
    <path
      d="M458.098 188.943c3.173 -0.422 9.975 -2.832 11.836 -9.088"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M447.745 183.87c2.114 0.071 6.973 -0.972 9.51 -5.706"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M438.235 176.262c3.38 -0.702 10.735 -2.89 13.102 -6.02"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M468.816 199.571c-21.262 4.748 -41.088 -16.431 -48.941 -28.447 -0.295 -0.45 -0.075 -1.047 0.436 -1.218l33.48 -11.229a0.847 0.847 0 0 1 0.872 0.213c11.15 11.42 31.885 16.445 42.787 17.81 0.76 0.095 1.026 1.08 0.411 1.533l-28.738 21.196c-0.091 0.068 -0.195 0.116 -0.307 0.141Z"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M310.255 128.509c-17.27 -0.715 -36.1 8.36 -39.31 10.768 -2.642 1.982 -2.274 4.931 -1.73 6.249q0.039 0.092 0.1 0.17l31.604 40.874q0.037 0.048 0.067 0.1c0.667 1.118 2.679 2.477 5.676 -0.686 4.715 -4.977 24.745 -17.6 50.248 -17.387 0.786 0.006 1.173 -0.983 0.578 -1.496l-24.407 -21.064"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M236.073 163.826c8.242 -4.472 9.933 5.495 14.371 4.65 5.712 -1.088 -3.804 -13.103 -12.892 -13.737 -7.27 -0.507 -21.627 10.919 -27.897 16.696 -11.413 11.072 -47.595 23.233 -101.023 -16.696"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M102.67 81.221c6.064 -18.171 0.388 -29.841 -3.208 -33.405 11.772 10.941 26.373 9.134 32.202 6.863l-0.433 8.614c9.098 3.166 14.341 -8.991 15.827 -15.465 2.291 -9.989 -5.76 -24.915 -28.788 -25.188s-39.346 15.015 -44.627 22.693c-14.616 -8.047 -34.224 -0.301 -42.201 4.578 -8.254 5.07 -27.09 21.858 -22.591 46.686 6.069 33.498 43.237 34.397 49.721 32.791 22.406 -5.552 36.518 -25.452 44.098 -48.166"
      fill="url(#coolGradient)"
    />
    <path
      d="M133.615 85.037c-1.21 3.022 -3.006 5.424 -4.882 6.879 -1.897 1.473 -3.702 1.865 -5.082 1.312 -1.379 -0.553 -2.414 -2.083 -2.77 -4.459 -0.352 -2.349 0.005 -5.327 1.216 -8.348 1.21 -3.022 3.006 -5.423 4.882 -6.879 1.897 -1.473 3.702 -1.865 5.082 -1.312 1.379 0.553 2.414 2.083 2.77 4.46 0.352 2.349 -0.006 5.326 -1.216 8.348Z"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M129.81 84.902a2.542 2.542 0 1 0 -2.676 -4.321 2.542 2.542 0 0 0 2.676 4.321"
      fill="black"
    />
    <path
      d="m103.323 79.711 17.794 2.064"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M133.196 64.191c0.768 3.333 3.578 10.885 7.263 15.615 3.769 4.838 3.03 9.684 -0.76 12.399l-5.92 4.282c-2.11 20.198 -9.337 33.804 -34.923 34.841"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m64.527 149.449 17.35 8.155c0.563 0.265 1.196 -0.176 1.15 -0.802l-1.311 -17.686c-0.049 -0.656 0.644 -1.096 1.21 -0.77l12.187 7.02"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M90.971 131.299c1.184 1.198 2.96 3.188 4.777 5.574 2.495 3.274 5.069 7.294 6.294 11.033"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M96.955 159.117c1.122 -0.33 1.71 -1.689 1.314 -3.036 -0.396 -1.346 -1.627 -2.17 -2.749 -1.839s-1.71 1.689 -1.314 3.036 1.627 2.17 2.749 1.839"
      fill="url(#coolGradient)"
    />
    <path
      d="M102.946 169.714c1.01 -0.297 1.507 -1.63 1.11 -2.976s-1.537 -2.196 -2.546 -1.899 -1.507 1.63 -1.11 2.976 1.537 2.196 2.546 1.899"
      fill="url(#coolGradient)"
    />
    <path
      d="M118.491 109.449c-0.648 1.544 -0.75 5.028 4.03 6.62"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M208.661 251.295c-0.783 -4.998 -0.988 -8.193 -0.843 -10.569 0.031 -0.504 -1.24 -0.991 -1.529 -0.576 -5.173 7.448 -11.443 10.999 -14.67 12.958a0.395 0.395 0 0 0 -0.182 0.244c-1.506 5.87 -3.665 19.206 3.85 22.652 9.48 4.345 15.071 -13.881 13.374 -24.707"
      fill="url(#coolGradient)"
    />
    <path
      d="M181.841 228.613c2.814 -0.419 8.688 -1.717 10.666 5.998 2.472 9.643 -10.316 42.277 5.487 41.867 12.642 -0.328 12.2 -24.28 10.182 -36.601"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M219.213 184.716c2.666 9.173 -0.437 18.608 -5.12 17.331 -2.806 -0.766 -3.652 -5.106 -3.906 -8.877 -0.459 -6.551 -0.743 -20.373 1.793 -23.248"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M210.711 193.804c2.195 -1.409 7.397 -6.129 8.665 -9.299 2.748 9.299 -0.032 18.525 -5.284 17.541 -3.382 -0.634 -3.382 -4.649 -3.382 -8.242"
      fill="url(#coolGradient)"
    />
    <path
      d="M183.755 276.488c-47.928 -23.469 -132.448 55.262 -111.872 -101.168"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M57.919 155.289C18.842 199.751 32.997 247.183 5.553 285.299"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M240.511 155.373c6.129 -1.902 8.877 0 12.892 9.088"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M230.367 164.523c5.41 -0.507 10.191 1.056 12.258 2.958 5.284 4.861 0.634 6.974 -6.763 4.016 -4.377 -1.751 -3.71 5.317 -11.728 5.205 -1.034 -0.014 -1.997 0.608 -2.329 1.587 -1.69 4.985 -5.596 12.928 -11.305 14.881"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M228.676 206.062c0.916 -1.127 2.225 -2.117 2.959 -2.536 1.48 -0.845 7.186 2.113 3.593 -2.959 -4.284 -6.049 -19.021 4.297 -25.361 11.201C192.958 226.985 146.099 249.228 116.849 222.176"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M225.928 207.119c3.452 -0.353 10.314 -0.296 10.145 2.748"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M228.042 211.134c3.24 -1.057 9.679 -2.156 9.51 1.902"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M230.155 214.304c3.381 -1.409 9.299 -1.902 10.356 3.804 0.141 1.409 -0.296 3.635 -3.17 1.268s-6.411 -0.141 -7.82 1.268c-3.17 2.959 -10.61 9.003 -15.005 9.511 -5.072 7.538 -16.781 22.402 -23.037 21.557"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M122.158 212.328c43.114 27.897 52.625 -4.227 85.172 -4.227"
      stroke="url(#coolGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m233.114 270.945 145.25 -30.435a0.831 0.831 0 0 1 1.001 0.813v3.168a0.831 0.831 0 0 1 -0.656 0.812l-149.451 32.189a0.831 0.831 0 0 1 -1.006 -0.812v-4.255l-3.804 -46.074"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m229.15 278.416 -7.561 1.512a0.415 0.415 0 0 1 -0.496 -0.427l2.457 -50.278c0.025 -0.512 0.775 -0.533 0.828 -0.023l5.103 48.766a0.415 0.415 0 0 1 -0.331 0.45"
      fill="black"
    />
    <path
      d="m235.228 258.898 138.703 -28.328a0.831 0.831 0 0 1 0.997 0.814v8.916"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m224.026 199.933 -2.113 -20.5"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M308.353 192.747c1.902 -2.606 8.412 -8.665 19.233 -12.047 13.526 -4.227 45.651 -19.867 47.975 12.047 0.141 8.313 0 15.217 -2.748 37.197"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M292.732 194.438c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.17c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.17Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M288.505 188.098c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M284.278 181.757c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.17c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.17Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M280.051 175.628c0 0.175 -0.157 0.59 -0.988 1.022 -0.78 0.406 -1.93 0.688 -3.257 0.688 -1.327 0 -2.477 -0.282 -3.257 -0.688 -0.831 -0.432 -0.988 -0.846 -0.988 -1.022 0 -0.175 0.157 -0.589 0.988 -1.022 0.78 -0.406 1.93 -0.688 3.257 -0.688s2.477 0.282 3.257 0.688c0.831 0.432 0.988 0.847 0.988 1.022Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M275.824 169.499c0 0.118 -0.112 0.48 -0.866 0.873 -0.703 0.367 -1.747 0.625 -2.957 0.625s-2.254 -0.258 -2.957 -0.625c-0.754 -0.393 -0.866 -0.755 -0.866 -0.873s0.112 -0.48 0.866 -0.873c0.703 -0.367 1.747 -0.625 2.957 -0.625s2.253 0.258 2.957 0.625c0.754 0.393 0.866 0.755 0.866 0.873Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M271.598 163.37c0 0.062 -0.068 0.37 -0.744 0.724 -0.626 0.328 -1.564 0.562 -2.657 0.562 -1.092 0 -2.03 -0.234 -2.657 -0.562 -0.676 -0.354 -0.743 -0.662 -0.743 -0.724s0.068 -0.37 0.743 -0.724c0.627 -0.328 1.564 -0.562 2.657 -0.562s2.03 0.234 2.657 0.562c0.676 0.354 0.744 0.662 0.744 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M282.165 205.428c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.17c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.17Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M278.36 199.088c0 0.232 -0.202 0.699 -1.111 1.17 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.17s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M275.402 192.747c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M272.02 186.196c0 0.175 -0.157 0.589 -0.988 1.022 -0.78 0.406 -1.93 0.688 -3.257 0.688s-2.477 -0.282 -3.257 -0.688c-0.831 -0.432 -0.988 -0.847 -0.988 -1.022 0 -0.175 0.157 -0.59 0.988 -1.022 0.78 -0.405 1.93 -0.687 3.257 -0.687 1.327 0 2.477 0.282 3.257 0.687 0.831 0.432 0.988 0.847 0.988 1.022Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M268.639 180.066c0 0.118 -0.112 0.48 -0.866 0.873 -0.703 0.367 -1.747 0.625 -2.957 0.625s-2.254 -0.258 -2.957 -0.625c-0.754 -0.393 -0.866 -0.755 -0.866 -0.873s0.112 -0.48 0.866 -0.873c0.703 -0.367 1.747 -0.625 2.957 -0.625 1.21 0 2.253 0.258 2.957 0.625 0.754 0.393 0.866 0.755 0.866 0.873Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M265.68 174.36c0 0.062 -0.068 0.37 -0.743 0.724 -0.627 0.328 -1.564 0.562 -2.657 0.562s-2.03 -0.234 -2.657 -0.562c-0.676 -0.354 -0.744 -0.662 -0.744 -0.724s0.068 -0.37 0.744 -0.724c0.626 -0.328 1.564 -0.562 2.657 -0.562 1.092 0 2.03 0.234 2.657 0.562 0.676 0.354 0.743 0.662 0.743 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M263.566 169.288c0 0.062 -0.068 0.37 -0.744 0.724 -0.626 0.328 -1.564 0.562 -2.657 0.562 -1.092 0 -2.03 -0.234 -2.657 -0.562 -0.676 -0.354 -0.743 -0.662 -0.743 -0.724s0.068 -0.37 0.743 -0.724c0.627 -0.328 1.564 -0.562 2.657 -0.562s2.03 0.234 2.657 0.562c0.676 0.354 0.744 0.662 0.744 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M261.453 164.216c0 0.062 -0.068 0.37 -0.743 0.724 -0.627 0.328 -1.564 0.562 -2.657 0.562 -1.092 0 -2.03 -0.234 -2.657 -0.562 -0.676 -0.354 -0.743 -0.662 -0.743 -0.724s0.068 -0.37 0.743 -0.724c0.627 -0.328 1.564 -0.562 2.657 -0.562s2.03 0.234 2.657 0.562c0.676 0.354 0.743 0.662 0.743 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M269.907 215.15c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171 0 -0.232 0.202 -0.699 1.111 -1.17 0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.17Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M267.793 207.541c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M265.257 200.355c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M262.721 193.804c0 0.175 -0.157 0.59 -0.988 1.022 -0.78 0.406 -1.93 0.687 -3.257 0.687s-2.477 -0.282 -3.257 -0.687c-0.831 -0.432 -0.988 -0.847 -0.988 -1.022s0.157 -0.589 0.988 -1.022c0.78 -0.406 1.93 -0.688 3.257 -0.688s2.477 0.282 3.257 0.688c0.831 0.432 0.988 0.847 0.988 1.022Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M259.762 187.675c0 0.118 -0.112 0.48 -0.866 0.873 -0.703 0.367 -1.747 0.625 -2.957 0.625s-2.253 -0.258 -2.957 -0.625c-0.754 -0.393 -0.866 -0.755 -0.866 -0.873s0.112 -0.48 0.866 -0.873c0.703 -0.367 1.747 -0.625 2.957 -0.625s2.254 0.258 2.957 0.625c0.754 0.393 0.866 0.755 0.866 0.873Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M256.803 181.968c0 0.062 -0.068 0.37 -0.743 0.724 -0.627 0.328 -1.564 0.562 -2.657 0.562s-2.03 -0.234 -2.657 -0.562c-0.676 -0.354 -0.743 -0.662 -0.743 -0.724s0.068 -0.37 0.743 -0.724c0.627 -0.328 1.564 -0.562 2.657 -0.562s2.03 0.234 2.657 0.562c0.676 0.354 0.743 0.662 0.743 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M254.69 176.896c0 0.062 -0.068 0.37 -0.743 0.724 -0.627 0.328 -1.564 0.562 -2.657 0.562s-2.03 -0.234 -2.657 -0.562c-0.676 -0.354 -0.744 -0.662 -0.744 -0.724s0.068 -0.37 0.744 -0.724c0.627 -0.328 1.564 -0.562 2.657 -0.562 1.092 0 2.03 0.234 2.657 0.562 0.676 0.354 0.743 0.662 0.743 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M252.576 171.824c0 0.062 -0.068 0.37 -0.743 0.724 -0.627 0.328 -1.564 0.562 -2.657 0.562s-2.03 -0.234 -2.657 -0.562c-0.676 -0.354 -0.744 -0.662 -0.744 -0.724s0.068 -0.37 0.744 -0.724c0.626 -0.328 1.564 -0.562 2.657 -0.562 1.092 0 2.03 0.234 2.657 0.562 0.676 0.354 0.743 0.662 0.743 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M256.38 218.954c0 0.232 -0.202 0.699 -1.111 1.171 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.171s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M254.267 211.346c0 0.232 -0.202 0.699 -1.111 1.17 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.17s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M251.731 204.16c0 0.232 -0.202 0.699 -1.111 1.17 -0.857 0.444 -2.113 0.75 -3.557 0.75 -1.444 0 -2.7 -0.306 -3.557 -0.75 -0.909 -0.471 -1.111 -0.939 -1.111 -1.17s0.202 -0.699 1.111 -1.171c0.857 -0.444 2.113 -0.75 3.557 -0.75 1.444 0 2.7 0.306 3.557 0.75 0.909 0.471 1.111 0.939 1.111 1.171Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M249.195 197.608c0 0.175 -0.157 0.589 -0.988 1.022 -0.78 0.406 -1.93 0.688 -3.257 0.688s-2.477 -0.282 -3.257 -0.688c-0.831 -0.432 -0.988 -0.847 -0.988 -1.022s0.157 -0.589 0.988 -1.022c0.78 -0.406 1.93 -0.688 3.257 -0.688s2.477 0.282 3.257 0.688c0.831 0.432 0.988 0.847 0.988 1.022Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M247.504 191.479c0 0.118 -0.112 0.48 -0.866 0.873 -0.703 0.367 -1.747 0.625 -2.957 0.625s-2.254 -0.258 -2.957 -0.625c-0.753 -0.393 -0.865 -0.755 -0.865 -0.873s0.112 -0.48 0.865 -0.873c0.703 -0.367 1.748 -0.625 2.957 -0.625s2.253 0.258 2.957 0.625c0.754 0.393 0.866 0.755 0.866 0.873Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M245.391 185.773c0 0.062 -0.068 0.37 -0.744 0.724 -0.626 0.328 -1.564 0.562 -2.657 0.562 -1.092 0 -2.03 -0.234 -2.657 -0.562 -0.676 -0.354 -0.743 -0.662 -0.743 -0.724s0.068 -0.37 0.743 -0.724c0.627 -0.328 1.564 -0.562 2.657 -0.562s2.03 0.234 2.657 0.562c0.676 0.354 0.744 0.662 0.744 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M244.123 180.7c0 0.062 -0.068 0.37 -0.743 0.724 -0.627 0.328 -1.564 0.563 -2.657 0.563s-2.03 -0.234 -2.657 -0.563c-0.676 -0.354 -0.744 -0.662 -0.744 -0.724s0.068 -0.37 0.744 -0.724c0.626 -0.328 1.564 -0.563 2.657 -0.563 1.092 0 2.03 0.234 2.657 0.563 0.676 0.354 0.743 0.662 0.743 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="M242.855 175.628c0 0.062 -0.068 0.37 -0.744 0.724 -0.626 0.328 -1.564 0.563 -2.657 0.563 -1.092 0 -2.03 -0.234 -2.657 -0.563 -0.676 -0.354 -0.743 -0.662 -0.743 -0.724s0.068 -0.37 0.743 -0.724c0.627 -0.328 1.564 -0.563 2.657 -0.563s2.03 0.234 2.657 0.563c0.676 0.354 0.744 0.662 0.744 0.724Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
    />
    <path
      d="m230.367 198.031 -1.993 -12.556a0.831 0.831 0 0 1 0.627 -0.938l3.69 -0.886a0.831 0.831 0 0 1 1.01 0.652l5.755 30.212"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M242.625 231.846c12.117 -3.522 40.198 -12.638 56.429 -32.759"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M253.615 158.298c3.522 -1.198 9.51 -4.227 12.892 -11.201"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M309.63 166.141c-1.883 0.859 -5.01 3.368 -6.778 4.895a0.418 0.418 0 0 1 -0.652 -0.138l-12.711 -27.131c-0.203 -0.434 0.368 -0.81 0.686 -0.452l19.635 22.09c0.205 0.23 0.1 0.608 -0.18 0.735"
      fill="black"
    />
    <path
      d="M301.891 170.711c-2.969 -3.718 -14.317 -17.496 -20.286 -24.725 -0.191 -0.231 -0.244 -0.545 -0.094 -0.805 1.075 -1.867 4.241 -3.439 6.318 -3.914 0.277 -0.063 0.561 0.041 0.75 0.253l20.787 23.386c0.409 0.461 0.207 1.241 -0.332 1.539 -1.798 0.992 -4.315 2.997 -5.927 4.375 -0.366 0.313 -0.915 0.268 -1.215 -0.108Z"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M308.776 134.416c-1.12 0 -2.733 0.329 -3.678 1.425 -0.229 0.266 -0.189 0.651 0.041 0.916 5.995 6.875 17.744 17.764 20.813 21.088 0.326 0.353 0.88 0.388 1.272 0.109 1.121 -0.797 2.103 -1.027 3.2 -1.274 0.569 -0.128 0.805 -0.79 0.459 -1.26l-2.24 -3.04"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      cx="850.914"
      cy="465.662"
      rx="25.446"
      ry="25.9549"
      fill="black"
      d="M363.937 193.381A10.567 10.779 0 0 1 353.37 204.16A10.567 10.779 0 0 1 342.802 193.381A10.567 10.779 0 0 1 363.937 193.381z"
    />
    <path
      d="M308.142 139.277c1.178 -11.918 8.217 -36.212 26.949 -39.582 0.597 -0.107 1.205 0.077 1.664 0.473 4.718 4.073 14.681 11.836 24.337 16.9 1.468 0.77 1.606 2.887 0.224 3.803 -12.252 8.127 -32.258 23.959 -34.575 36.158"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M314.905 134.838c1.62 1.973 5.833 6.594 9.722 9.299"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M316.596 126.385c2.255 2.779 8.116 9.292 13.526 13.103"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M331.812 107.786c2.255 2.779 8.116 9.292 13.526 13.103"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M318.286 117.931c3.029 3.497 10.906 11.689 18.176 16.485"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M322.936 110.745c3.381 3.945 11.751 12.343 19.866 17.753"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M353.37 206.907c2.818 0.353 8.919 -0.422 10.779 -6.34"
      stroke="black"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M290.726 76.789a0.831 0.831 0 0 1 0.721 -0.299c8.919 0.826 22.471 -0.318 24.096 -7.002 1.652 -6.794 -4.656 -9.279 -8.016 -9.672 -12.751 -1.999 -29.644 -1.068 -29.755 9.566"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M288.487 70.378a1.48 1.48 0 1 0 0 -2.959 1.48 1.48 0 0 0 0 2.959"
      fill="url(#warmGradient)"
    />
    <path
      d="M298.42 68.899c0 0.718 -0.574 1.48 -1.48 1.48s-1.479 -0.761 -1.479 -1.48 0.574 -1.479 1.479 -1.479c0.906 0 1.48 0.761 1.48 1.479"
      fill="url(#warmGradient)"
    />
    <path
      d="M305.817 70.378a1.48 1.48 0 1 0 0 -2.959 1.48 1.48 0 0 0 0 2.959"
      fill="url(#warmGradient)"
    />
    <path
      d="M445.183 90.65c-0.062 0.215 -0.037 0.443 0.071 0.639 3.522 6.412 7.076 16.946 2.596 20.339 -4.551 3.447 -8.463 -0.47 -9.85 -2.859 -5.64 -8.892 -10.432 -21.832 -2.537 -25.391"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M436.437 92.174a1.208 1.208 0 1 0 2.217 -0.962 1.208 1.208 0 0 0 -2.217 0.962"
      fill="url(#warmGradient)"
    />
    <path
      d="M440.777 99.134c-0.54 0.233 -1.296 0.051 -1.591 -0.627s0.091 -1.356 0.627 -1.59c0.54 -0.234 1.296 -0.051 1.591 0.627s-0.087 1.356 -0.627 1.59"
      fill="url(#warmGradient)"
    />
    <path
      d="M442.072 105.157a1.21 1.21 0 0 0 1.591 0.627 1.206 1.206 0 0 0 0.627 -1.59 1.208 1.208 0 1 0 -2.218 0.963"
      fill="url(#warmGradient)"
    />
    <path
      d="M379.966 97.541c0.201 -0.149 0.324 -0.378 0.338 -0.628 0.356 -6.258 2.514 -15.448 7.223 -15.902 4.809 -0.464 5.867 4.153 5.794 6.52 0.072 9.035 -2.28 20.648 -9.564 19.65"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="M386.935 100.17a1.057 1.057 0 1 0 -2.092 -0.306 1.057 1.057 0 0 0 2.092 0.306"
      fill="url(#warmGradient)"
    />
    <path
      d="M386.9 93.116c0.508 0.074 0.986 0.559 0.892 1.199s-0.691 0.967 -1.199 0.892c-0.507 -0.074 -0.986 -0.559 -0.892 -1.199s0.691 -0.967 1.199 -0.892"
      fill="url(#warmGradient)"
    />
    <path
      d="M388.65 88.459a1.056 1.056 0 1 0 -2.091 -0.306 1.056 1.056 0 0 0 2.091 0.306"
      fill="url(#warmGradient)"
    />
    <path
      d="M398.257 133.788c-3.179 -1.011 -3.6 1.713 -3.347 3.846 0.044 0.371 -0.385 0.673 -0.72 0.507 -1.532 -0.757 -3.694 -1.294 -4.387 0.508 -0.814 2.115 4.57 4.53 7.676 5.588a0.411 0.411 0 0 0 0.506 -0.23c3.01 -7.012 1.45 -9.734 0.271 -10.22"
      fill="url(#warmGradient)"
    />
    <path
      d="M356.834 45.868c-3.179 -1.012 -3.6 1.713 -3.347 3.845 0.044 0.372 -0.385 0.673 -0.72 0.507 -1.532 -0.757 -3.694 -1.294 -4.387 0.508 -0.814 2.115 4.57 4.53 7.676 5.588a0.409 0.409 0 0 0 0.506 -0.23c3.01 -7.012 1.449 -9.734 0.271 -10.219"
      fill="url(#warmGradient)"
    />
    <path
      d="m426.071 137.163 31.914 -5.284"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m409.165 76.93 31.279 -24.093"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m357.174 91.724 13.315 -36.774"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
    <path
      d="m334.348 71.223 -2.536 -20.078"
      stroke="url(#warmGradient)"
      strokeWidth="2.0764119601328903"
      strokeLinecap="round"
    />
  </svg>
);

export const NoGuestsSVG = () => (
  <svg
    width="100%"
    viewBox="0 0 584 506"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M243.781 427.863C249.76 345.161 240.194 184.341 154.105 202.675C68.0152 221.009 64.4281 324.569 73.3958 374.057C81.367 402.953 127.002 389.601 90.3346 296.338"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M60.4425 286.372C36.1966 285.708 -20.4268 310.88 13.6114 395.977C57.4531 505.583 282.641 568.354 348.404 395.977"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M407.191 343.168C390.253 323.24 371.321 343.168 353.385 323.24V373.5C356.574 381.471 364.063 373.5 368.332 370.071L407.191 343.168Z"
      fill="black"
    />
    <path
      d="M444.058 316.265L361.292 375.384C357.982 377.748 353.385 375.382 353.385 371.315V262.459"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M394.238 239.542L459.004 109.013"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M492.882 111.006L419.148 261.463"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M516.796 140.898L453.026 269.435"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M434.095 97.0566L356.351 255.496C355.972 256.268 356.679 257.142 357.52 256.964C370.018 254.319 391.422 255.713 393.15 279.575C393.207 280.359 394.089 280.833 394.76 280.425C405.765 273.735 424.616 268.886 424.208 296.029C424.195 296.901 425.223 297.437 425.92 296.912C435.657 289.566 451.723 283.263 452.972 305.687C453.032 306.759 454.574 307.136 455.047 306.172L535.728 141.895"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M525.764 4.3905C492.284 -1.18937 476.608 11.3653 472.954 18.3402L452.807 57.6752C452.459 58.355 452.95 59.1608 453.713 59.1463C481.17 58.627 537.288 68.8195 554.777 106.991C555.134 107.771 556.255 107.815 556.638 107.048L561.634 97.0562L581.388 56.5602C581.5 56.3311 581.524 56.0782 581.446 55.8354C576.624 40.7499 558.97 9.92496 525.764 4.3905Z"
      fill="black"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M554.659 110.009L539.058 139.377C538.614 140.212 537.319 140.047 537.055 139.139C531.756 120.912 505.413 88.381 440.668 87.1165C439.937 87.1022 439.439 86.3365 439.755 85.6771L451.033 62.1816"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
    <path
      d="M457.012 75.1355C470.629 73.1428 505.636 76.7301 536.724 107.02"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);

export const NotFoundSVG = () => (
  <svg
    width="100%"
    viewBox="0 0 500 340.229"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M230.302 170.821c5.128 -5.144 15.464 -13.89 15.788 -7.717 0.405 7.717 -9.716 27.618 0 18.683 9.716 -8.935 21.456 -24.775 22.265 -18.683 0.809 6.092 2.024 7.717 13.359 -3.25"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M33.584 258.804c1.891 2.572 7.942 7.579 17.019 7.035"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M147.5 270.151c-8.971 4.901 -35.224 9.545 -68.65 -10.913 -0.189 -0.116 -0.433 -0.085 -0.574 0.087 -6.15 7.475 -24.59 23.606 -48.777 25.576 -7.035 0.574 -12.027 -2.95 -3.858 -5.9 4.539 -1.639 7.942 -2.723 9.531 -4.311"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M22.011 281.043c-4.539 2.118 -10.439 3.54 -11.347 -0.454 -1.134 -4.993 7.035 -4.085 10.212 -6.581"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M9.984 280.816c-7.716 2.269 -11.296 -4.564 -4.538 -7.942 6.354 -3.177 11.8 -2.043 15.885 -6.808"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M3.176 274.462c-1.74 -1.513 -3.813 -5.401 1.815 -8.85 7.035 -4.312 39.939 -18.835 35.854 -30.408 -1.201 -3.404 -7.715 -3.176 -13.162 -10.211 -4.045 -5.225 0 -11.346 4.993 -7.942 1.286 0.983 9.213 6.127 13.389 4.312 5.207 -2.264 22.382 -4.302 34.631 11.234a0.44 0.44 0 0 0 0.219 0.151c10.05 2.949 32.455 7.288 42.758 1.323"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M46.519 242.466c2.799 2.647 10.665 3.631 15.658 -1.135"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M466.29 256.106c-1.888 2.572 -7.94 7.579 -17.016 7.034"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M352.375 267.452c8.971 4.901 35.224 9.545 68.65 -10.913 0.189 -0.116 0.433 -0.084 0.574 0.087 6.15 7.475 24.59 23.606 48.776 25.576 7.038 0.574 12.029 -2.95 3.86 -5.9 -4.538 -1.639 -7.945 -2.723 -9.533 -4.312"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M477.865 278.344c4.538 2.118 10.436 3.54 11.347 -0.454 1.131 -4.992 -7.038 -4.085 -10.211 -6.581"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M489.89 278.118c7.716 2.269 11.298 -4.564 4.538 -7.942 -6.351 -3.177 -11.8 -2.043 -15.885 -6.808"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M496.699 271.763c1.739 -1.513 3.812 -5.401 -1.813 -8.85 -7.038 -4.312 -39.938 -18.835 -35.854 -30.408 1.197 -3.404 7.711 -3.176 13.16 -10.211 4.045 -5.225 0 -11.346 -4.991 -7.942 -1.29 0.983 -9.217 6.127 -13.389 4.312 -5.207 -2.264 -22.384 -4.301 -34.632 11.234a0.44 0.44 0 0 1 -0.219 0.151c-10.05 2.949 -32.455 7.287 -42.758 1.323"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M453.358 239.767c-2.799 2.647 -10.669 3.631 -15.66 -1.134"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M225.658 77.623c1.713 19.535 10.481 53.987 31.769 55.323 22.426 1.407 31.769 -44.07 31.769 -55.791"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="m229.743 76.701 -6.354 -0.908"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M291.605 75.793c6.882 1.731 12.294 9.251 -4.223 23.6"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M222.679 75.793c-5.999 0.787 -12.313 9.912 6.156 23.6"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      cx="548.786"
      cy="180.966"
      rx="9.2803"
      ry="8.76473"
      fill="black"
      d="M245.628 79.651A4.085 3.858 0 0 1 241.543 83.508A4.085 3.858 0 0 1 237.458 79.651A4.085 3.858 0 0 1 245.628 79.651z"
    />
    <path
      cx="619.419"
      cy="180.966"
      r="8.76473"
      fill="black"
      d="M276.489 79.651A3.858 3.858 0 0 1 272.632 83.508A3.858 3.858 0 0 1 268.774 79.651A3.858 3.858 0 0 1 276.489 79.651z"
    />
    <path
      cx="549.817"
      cy="180.45"
      r="29.4655"
      stroke="black"
      strokeWidth="2.200704225352113"
      d="M254.966 79.423A12.969 12.969 0 0 1 241.997 92.392A12.969 12.969 0 0 1 229.028 79.423A12.969 12.969 0 0 1 254.966 79.423z"
    />
    <path
      d="M284.92 79.423c0 7.18 -5.722 12.969 -12.742 12.969s-12.742 -5.79 -12.742 -12.969c0 -7.179 5.722 -12.969 12.742 -12.969s12.742 5.79 12.742 12.969Z"
      stroke="black"
      strokeWidth="2.200704225352113"
    />
    <path
      d="M254.251 78.062h5.446"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M252.048 86.685c-1.18 6.543 -1.311 17.406 10.372 11.424"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M249.258 112.101c2.496 -1.37 8.986 -3.288 14.977 0"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M283.751 75.793h7.715"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M221.859 37.908c-23.814 11.213 -12.713 30.836 -4.186 39.246 1.489 -1.121 6.202 -1.402 8.372 -1.402 -4.093 -29.902 11.318 -37.845 18.139 -39.714 19.07 -3.27 40.93 1.869 44.651 16.82 4.445 17.86 4.585 23.828 8.04 24.295 13.129 -10.466 11.193 -30.525 8.584 -39.246 3.404 -9.742 -4.199 -18.533 -8.584 -23.828S280.462 -0.871 259.067 0.063c-42.325 4.205 -39.534 30.369 -37.209 37.845"
      fill="black"
    />
    <path
      d="M233.827 60.816c1.929 -0.342 7.716 -0.822 15.431 0"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M265.597 61.724c1.815 -0.685 7.261 -1.644 14.523 0"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M236.455 130.819c-44.931 -3.177 -56.005 -9.576 -88.5 68.305"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M279.987 129.18c38.577 6.807 57.185 -16.793 82.6 61.043"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M174.958 248.366c-4.774 22.809 -19.981 24.364 -27.548 22.193 -0.291 -0.084 -0.387 -0.446 -0.206 -0.69 17.192 -23.1 -9.45 -40.172 -23.106 -35.72a0.44 0.44 0 0 1 -0.561 -0.295c-2.564 -9.134 12.322 -10.65 13.751 -23.158 0.726 -6.354 1.588 -9.604 5.219 -9.758 16.111 -0.681 38.577 18.154 32.45 47.427Z"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M365.764 193.172c3.817 17.74 16.079 26.369 11.497 38.202 -0.082 0.211 -0.327 0.322 -0.544 0.258 -28.863 -8.428 -35.094 24.949 -23.256 35.22 0.311 0.27 0.149 0.801 -0.263 0.805 -19.601 0.176 -34.542 -32.534 -30.096 -44.985 12.481 -34.946 41.343 -35.627 42.662 -29.5Z"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M328.776 251.038c-0.151 30.03 0.408 61.315 4.765 86.004"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M175.866 245.643c0.303 29.651 -0.59 63.675 -5.673 93.266"
      stroke="black"
      strokeWidth="2.200704225352113"
      strokeLinecap="round"
    />
    <path
      d="M275.864 140.254c2.02 -5.668 0.173 -9.482 -1.619 -10.209 -10.798 9.592 -27.177 6.031 -33.244 0.217 -2.162 1.919 -0.904 7.594 0 9.338 11.694 12.558 28.34 5.523 34.863 0.654"
      fill="black"
    />
  </svg>
);

export const InfoSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-info"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);

export const PersonalMessageSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-message-circle-heart"
  >
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    <path d="M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7" />
  </svg>
);

export const RemoveGuestSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-user-minus"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="22" x2="16" y1="11" y2="11" />
  </svg>
);

export const AddGuestSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-user-plus"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="19" x2="19" y1="8" y2="14" />
    <line x1="22" x2="16" y1="11" y2="11" />
  </svg>
);

export const FontSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-case-sensitive"
  >
    <path d="m3 15 4-8 4 8" />
    <path d="M4 13h6" />
    <circle cx="18" cy="12" r="3" />
    <path d="M21 9v6" />
  </svg>
);

export const FontPlusSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-a-arrow-up"
  >
    <path d="M3.5 13h6" />
    <path d="m2 16 4.5-9 4.5 9" />
    <path d="M18 16V7" />
    <path d="m14 11 4-4 4 4" />
  </svg>
);

export const FontMinusSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-a-arrow-down"
  >
    <path d="M3.5 13h6" />
    <path d="m2 16 4.5-9 4.5 9" />
    <path d="M18 7v9" />
    <path d="m14 12 4 4 4-4" />
  </svg>
);

export const ColorPalleteSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-palette"
  >
    <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
    <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
    <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
    <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
  </svg>
);

export const MenuSVG = () => (
  <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
  </svg>
);

export const EditableImageSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-image h-5 w-5"
  >
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
  </svg>
);

export const RefreshSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-refresh-ccw"
  >
    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
    <path d="M3 3v5h5" />
    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
    <path d="M16 16h5v5" />
  </svg>
);

export const BoldSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-bold"
  >
    <path d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8" />
  </svg>
);

export const ItalicSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-italic"
  >
    <line x1="19" x2="10" y1="4" y2="4" />
    <line x1="14" x2="5" y1="20" y2="20" />
    <line x1="15" x2="9" y1="4" y2="20" />
  </svg>
);
